import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import { es } from './languages';

export const enum LanguagesAllowed {
	SPANISH = 'es',
}

const resources = {
	es: { translation: es },
};

i18n.use(LanguageDetector).use(initReactI18next).init({
	lng: LanguagesAllowed.SPANISH,
	resources,
});

export default i18n;
